// Public routes
import Test from "./test/Test";
import Home from "./components/public_directory/home-page/Home";
import PricingPage from "./components/public_directory/public-routs-comps/Pricing";

// _____________________________________________________________
import CompanyLogin from "./components/public_directory/public-routs-comps/logins/CompanyLogin";
import Registration from "./components/public_directory/public-routs-comps/Registration";
import Stafflogin from "./components/public_directory/public-routs-comps/logins/StaffLogin";
import Aboutus from "./components/public_directory/public-routs-comps/Aboutus";
import ContactUs from "./components/public_directory/public-routs-comps/Contactus";
import ExecutiveLogin from "./components/public_directory/public-routs-comps/logins/ExecutiveLogin";
import CEOWorkspace from "./universe_ceo_source_file/CEOWorkspace.jsx";
import CEOLogin from "./universe_ceo_source_file/CEOLogin.jsx";
import CEOProtectedRoute from "./universe_ceo_source_file/CEOProtectedRoute.jsx";
import COOLogin from "./universe_coo_source_file/COOLogin.jsx";
import COOProtectedRoute from "./universe_coo_source_file/COOProtectedRoute.jsx";

// Admin routes
import SDDLogin from "./components/public_directory/public-routs-comps/logins/SDDLogin";
import CareerFDCApplication from "./components/public_directory/careers_comps/careers-form/CareerFDCApplication.jsx";
import Careers from "./components/public_directory/careers_comps/Careers.jsx";
import FDCCareerSuccess from "./components/public_directory/careers_comps/careers-form/FDCCareerSuccess.jsx";
import FDCEmploymentAcceptance from "./components/public_directory/careers_comps/careers-form/FDCEmploymentAcceptance.jsx";
import AdminProfile from "./components/admin_directory/AdminProfile";
import CompanyAccount from "./components/clients-directory/CompanyAccount";
import SubscriptionRouteGate from "./components/universe-company-directrory/SubscriptionRouteGate.jsx";
import UserWorkspace from "./components/clients-directory/users-workspace/UserWorkspace";
import UserProfile from "./components/clients-directory/users-workspace/UserProfile";
import InventoryTerminal from "./components/clients-directory/clients-account-comps/point_of_sales_terminal/InventoryTerminal";
import InventoryTerminalX from "./components/clients-directory/clients-account-comps/point_of_sales_terminal_test/InventoryTerminal";
import SystemAdminAccount from "./components/system_admin_directory/SystemAdminAccount";
import FinanceAccount from "./components/finance_directory/FinanceAccount";
import AgentAccount from "./components/agent_directory/AgentAccount";
import UniverseStaffLogin from "./components/public_directory/public-routs-comps/logins/UniverseStaffLogin";
import ExecutiveOfficer from "./components/directorate_of_chief_executive_officer/ExecutiveOfficer";
import FinanceLogin from "./components/public_directory/public-routs-comps/logins/FinanceLogin";

import AgentLogin from "./components/public_directory/public-routs-comps/logins/AgentLogin";
import SystemAdminLogin from "./components/public_directory/public-routs-comps/logins/SystemAdminLogin";
import AdminStaffAccount from "./components/staff_directory/AdminStaffAccount";
import CLIENTPrinting from "./components/clients-directory/clients-account-comps/printing/CLIENTPrinting";
import RealtimeDetailPage from "./components/public_directory/destination-pages/RealtimeDetailPage";
import IndustriesCategories from "./components/public_directory/destination-pages/IndustriesCategories";
import SolutionsCategories from "./components/public_directory/destination-pages/SolutionsCategories";
import CompanyFeatures from "./components/public_directory/destination-pages/CompanyFeatures";
import Enterprise from "./components/public_directory/Enterprise";
import MobileAppDetailPage from "./components/public_directory/destination-pages/MobileAppDetailPage";
import InventoryPhotosDetailPage from "./components/public_directory/destination-pages/InventoryPhotoDetailPage";
import AlertsDetailPage from "./components/public_directory/destination-pages/AlertsDetailPage";
import BarcodeQrCodeDetailPage from "./components/public_directory/destination-pages/BarQrCodeDetailPage";
import ReportingAnalyticsDetailPage from "./components/public_directory/destination-pages/ReportingAnalyticsDetailPage";
import InventoryManagementDetailPage from "./components/public_directory/destination-pages/InventoryManagementDetailPage";
import SuppliesConsumablesDetailPage from "./components/public_directory/destination-pages/SuppliesConsumablesDetailPage";
import AssetTrackingDetailPage from "./components/public_directory/destination-pages/AssetTrackingDetailPage";
import PharmacyChemistDetailPage from "./components/public_directory/destination-pages/PharmacyChemistDetailPage";
import BuildingMaterialsDetailPage from "./components/public_directory/destination-pages/BuildingMaterialsDetailPage";
import ProvisionStoreDetailPage from "./components/public_directory/destination-pages/ProvisionStoreDetailPage";
import FurnituresDetailPage from "./components/public_directory/destination-pages/FurnituresDetailPage";
import ElectronicsDetailPage from "./components/public_directory/destination-pages/ElectronicsDetailPage";
import WholesaleDetailPage from "./components/public_directory/destination-pages/WholesaleDetailPage";
import RegAdditionalSetup from "./components/public_directory/public-routs-comps/registrationformComp/RegAdditionalSetup";
import QueryRegistration from "./components/public_directory/public-routs-comps/QueryRegistration";
import FDCEmploymentTerms from "./components/public_directory/careers_comps/careers-form/FDCEmploymentTerms.jsx";
import PointOfSaleLogin from "./components/clients-directory/clients-account-comps/point_of_sales_terminal/PointOfSalesLogin";
import PurchaseOrders from "./components/clients-directory/purchases/PurchaseOrders";
import RegistrationSuccess from "./components/public_directory/public-routs-comps/RegistrationSuccess";
import ClientProfileDashboard from "./components/clients-directory/client-account-pages/ClientProfileDashboard";
import InventoryPage from "./components/clients-directory/inventory-page/InventoryPage";
import TermsOfService from "./components/public_directory/TermsOfService";
import PublicLearning from "./components/public_directory/public-learnings-src/PublicLearning";
import FDCWorkspace from "./components/staff_directory/universe-fdc-sprint1/FDCWorkspace";
import SDDWorkspace from "./components/staff_directory/universe-sdd-comps/SDDWorkspace";
import ExecutiveDirectorLogin from "./components/public_directory/public-routs-comps/logins/ExecutiveDirectorLogin";
import ExecutiveDirectorWorkspace from "./components/staff_directory/universe-executive-director-sprint1/ExecutiveDirectorWorkspace";
import PointOfSaleLoginX from "./components/clients-directory/clients-account-comps/point_of_sales_terminal_test/PointOfSalesLogin";
import ExecutiveDirectorRegistration from "./components/staff_directory/ExecutiveDirectorRegistration";
import UniverseApplications from "./components/universe_app_store/UniverseApplications.jsx";
import ApplicationDetailsPage from "./components/universe_app_store/pages/ApplicationDetailsPage.jsx";
import CompanyInformationPage from "./components/public_directory/destination-pages/CompanyInformationPage.jsx";
import PublicPageNavigation from "./components/public_directory/layout/PublicPageNavigation.jsx";

// Only marketing/information pages without their own <Header /> are wrapped.
// Feature/solution pages already render Header and must not get a duplicate.
const withPublicNavigation = (page) => (
  <PublicPageNavigation>{page}</PublicPageNavigation>
);

const greenRoutes = [
  // Dedicated COO sign-in and fail-closed, role-checked operations workspace.
  { path: "/administration/coo/login", name: "COO Login", element: <COOLogin />, isPublic: true },
  { path: "/administration/coo-workspace", name: "COO Operations Workspace", element: <COOProtectedRoute />, isPublic: true },
  // PUBLIC ROUTES
  {
    path: "/administration/ceo/login",
    name: "CEO Login",
    element: <CEOLogin />,
    isPublic: true,
  },
  {
    path: "/administration/ceo-workspace",
    name: "CEO Workspace",
    element: <CEOProtectedRoute />,
    isPublic: true, // Access is enforced by CEOProtectedRoute and backend session checks.
  },
  { path: "/test", name: "home", element: <Test />, isPublic: true },
  { path: "/", name: "home", element: <Home />, isPublic: true },
  {
    path: "/information-technology/system-administration/login",
    name: "login",
    element: <SystemAdminLogin />,
    isPublic: true,
  },
  {
    path: "/executive/login",
    name: "Executive login",
    element: <ExecutiveLogin />,
    isPublic: true,
  },
  {
    path: "/pricing",
    name: "Pricing",
    element: <PricingPage />,
    isPublic: true,
  },

  {
    path: "/access/client-portal/authentication/sign-in",
    name: "login",
    element: <CompanyLogin />,
    isClientGuest: true,
  },
  //   /access
  // └── /client-portal
  //     └── /authentication
  //         ├── /sign-in
  //         ├── /sign-up
  //         ├── /forgot-password
  //         ├── /reset-password
  //         ├── /verify-email
  //         ├── /verify-otp
  //         ├── /two-factor-authentication
  //         ├── /security-check
  //         └── /session-expired

  {
    path: "/finance/finance_login",
    name: "",
    element: <FinanceLogin />,
    isPublic: true,
  },
  {
    path: "/agent_unit/login",
    name: "",
    element: <AgentLogin />,
    isPublic: true,
  },

  {
    path: "/staff_login",
    name: "staff login",
    element: <Stafflogin />,
    isPublic: true,
  },

  {
    path: "/about-us",
    name: "student_login",
    element: withPublicNavigation(<Aboutus />),
    isPublic: true,
  },
  {
    path: "/learning/:topic",
    name: "Learning topic",
    element: withPublicNavigation(<PublicLearning />),
    isPublic: true,
  },
  {
    path: "/learning/getting_started",
    name: "learning",
    element: withPublicNavigation(<PublicLearning />),
    isPublic: true,
  },
  {
    path: "/terms",
    name: "terms",
    element: withPublicNavigation(<TermsOfService />),
    isPublic: true,
  },
  {
    path: "/contact-us",
    name: "sgin",
    element: withPublicNavigation(<ContactUs />),
    isPublic: true,
  },

  {
    path: "/store/universe-mobile/application",
    name: "Mobile Application",
    element: withPublicNavigation(<UniverseApplications />),
    isPublic: true,
  },
  {
    path: "/store/universe-mobile/application/:slug",
    name: "Mobile Application Details",
    element: withPublicNavigation(<ApplicationDetailsPage />),
    isPublic: true,
  },
  {
    path: "/careers",
    name: "Careers at Universe Inventory",
    element: withPublicNavigation(<Careers />),
    isPublic: true,
  },
  {
    path: "/career",
    name: "Careers at Universe Inventory",
    element: withPublicNavigation(<Careers />),
    isPublic: true,
  },
  {
    path: "/career/field-development-consultant/application/acceptance",
    name: "Field Development Consultant Employee Acceptance",
    element: withPublicNavigation(<FDCEmploymentAcceptance />),
    isPublic: true,
  },
  {
    path: "/career/field-development-consultant/application/success",
    name: "Field Development Consultant Application Confirmation",
    element: withPublicNavigation(<FDCCareerSuccess />),
    isPublic: true,
  },
  {
    path: "/career/field-development-consultant/fdc-policy",
    name: "Field Development Consultant Career Application",
    element: withPublicNavigation(<FDCEmploymentTerms />),
    isPublic: true,
  },
  {
    path: "/career/field-development-consultant/application",
    name: "Field Development Consultant Career Application",
    element: withPublicNavigation(<CareerFDCApplication />),
    isPublic: true,
  },
  {
    path: "/administration/ed_reg",
    name: "admin staff_login",
    element: <ExecutiveDirectorRegistration />,
    isUniverseStaff: true,
    allowedStaffRoles: ["CEO"],
  },
  {
    path: "/executive_officer/workspaces",
    name: "admin staff_login",
    element: <CEOWorkspace />,
    isUniverseStaff: true,
    allowedStaffRoles: ["CEO"],
  },
  {
    path: "/administration/staff-login",
    name: "admin staff_login",
    element: <UniverseStaffLogin />,
    isPublic: true,
  },
  {
    path: "/administration/executive/login/ed",
    name: "State Development Director Login",
    element: <ExecutiveDirectorLogin />,
    isPublic: true,
  },
  {
    path: "/administration/sdd_login",
    name: "State Development Director Login",
    element: <SDDLogin />,
    isPublic: true,
  },
  {
    path: "/administration/workspace/fdc",
    name: "Field Development Consultant Workspace",
    element: <FDCWorkspace />,
    isUniverseStaff: true,
    allowedStaffRoles: ["FDC"],
  },

  {
    path: "/administration/sdd-workspace",
    name: "State Development Director Workspace",
    element: <SDDWorkspace />,
    isUniverseStaff: true,
    allowedStaffRoles: ["SDD"],
  },

  {
    path: "/administration/executive/director-teritory",
    name: "Executive Director Workspace",
    element: <ExecutiveDirectorWorkspace />,
    isUniverseStaff: true,
    allowedStaffRoles: ["ED"],
  },
  {
    path: "/enterprise",
    name: "Enterprise",
    element: withPublicNavigation(<Enterprise />),
    isPublic: true,
  },
  // Destination PAGE ROUTES
  {
    path: "/company/:section",
    name: "Company information",
    element: withPublicNavigation(<CompanyInformationPage />),
    isPublic: true,
  },
  {
    path: "/company/features",
    name: "",
    element: withPublicNavigation(<CompanyFeatures />),
    isPublic: true,
  },
  {
    path: "/solutions/industries",
    name: "",
    element: <IndustriesCategories />,
    isPublic: true,
  },
  {
    path: "/solutions/all-solutions",
    name: "",
    element: <SolutionsCategories />,
    isPublic: true,
  },
  {
    path: "/features/realtime_sales_tracking",
    name: "",
    element: <RealtimeDetailPage />,
    isPublic: true,
  },
  {
    path: "/features/mobile_application",
    name: "",
    element: <MobileAppDetailPage />,
    isPublic: true,
  },
  {
    path: "/features/inventory_photos",
    name: "",
    element: <InventoryPhotosDetailPage />,
    isPublic: true,
  },
  {
    path: "/features/alerts",
    name: "",
    element: <AlertsDetailPage />,
    isPublic: true,
  },
  {
    path: "/features/qr_barcoding",
    name: "",
    element: <BarcodeQrCodeDetailPage />,
    isPublic: true,
  },
  {
    path: "/features/reporting-analytics",
    name: "",
    element: <ReportingAnalyticsDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/inventory_management",
    name: "",
    element: <InventoryManagementDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/supplies_tracking",
    name: "",
    element: <SuppliesConsumablesDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/asset_tracking",
    name: "",
    element: <AssetTrackingDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/industries/healthcare/pharmacy_chemist",
    name: "",
    element: <PharmacyChemistDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/industries/construction/building_materials",
    name: "",
    element: <BuildingMaterialsDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/industries/provision_store",
    name: "",
    element: <ProvisionStoreDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/industries/electronics",
    name: "",
    element: <ElectronicsDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/industries/furnitures",
    name: "",
    element: <FurnituresDetailPage />,
    isPublic: true,
  },
  {
    path: "/solutions/industries/wholesale_distribution",
    name: "",
    element: <WholesaleDetailPage />,
    isPublic: true,
  },

  // ADMINISTRATION ROUTS
  {
    path: "/administration/admin-account",
    name: "Admin",
    element: <AdminProfile />,
    isAdmin: true,
  },

  {
    path: "/high_authority/executive_officer/dashboard/:id",
    name: "head of school",
    element: <ExecutiveOfficer />,
    isUniverseStaff: true,
    allowedStaffRoles: ["CEO"],
  },
  // SYSTEM ADMINISTRATION
  {
    path: "/website-management/system-adming/account",
    name: "head of school",
    element: <SystemAdminAccount />,
    isUniverseStaff: true,
    allowedStaffRoles: ["CEO"],
  },

  // FINANCE ROUTES
  {
    path: "/school-management/finance/account",
    name: "head of school",
    element: <FinanceAccount />,
    isFinance: true,
  },
  // Agent ROUTES

  {
    path: "/school-management/agent/account",
    name: "Agent dashboards",
    element: <AgentAccount />,
    isAgent: true,
  },

  // STAFFS ROUTES

  {
    path: "/school-management/account/staff_profile",
    name: "StaffChat",
    element: <AdminStaffAccount />,
    isUniverseStaff: true,
    allowedStaffRoles: ["CEO", "ED", "SDD", "FDC"],
  },

  // CLEINTS ROUTES
  {
    path: "/advance-companies-management-system/company-account",
    name: "clientDashboard",
    element: <CompanyAccount />,
    isCompanyAccount: true,
  },
  {
    path: "/inventory",
    name: "clientDashboard",
    element: (
      <SubscriptionRouteGate area="inventory management">
        <InventoryPage />
      </SubscriptionRouteGate>
    ),
    isCompanyAccount: true,
  },
  {
    path: "/cloud-profile-account/client-account",
    name: "clientDashboard",
    element: <ClientProfileDashboard />,
    isClientProfile: true,
  },
  {
    path: "/clients/users/workspace",
    name: "User Workspace",
    element: <UserWorkspace />,
    isCompanyUser: true,
  },
  {
    path: "/clients/users/profile",
    name: "User Profile",
    element: <UserProfile />,
    isCompanyUser: true,
  },
  {
    path: "/clients/workspace/terminal-login",
    name: "POS_terminal",
    element: <PointOfSaleLogin />,
    isPointOfSaleGuest: true,
  },
  {
    path: "/clients/workspace/terminal-login-test",
    name: "POS_terminal",
    element: <PointOfSaleLoginX />,
    isPointOfSaleGuest: true,
  },
  {
    path: "/clients/point-of-sale/workspace/inventory-transactions",
    name: "POS_terminal",
    element: <InventoryTerminal />,
    isPointOfSale: true,
  },
  {
    path: "/clients/point-of-sale/workspace/inventory-transactions-test",
    name: "POS_terminal",
    element: <InventoryTerminalX />,
    isPointOfSale: true,
  },
  {
    path: `/clients/:id/account/data_printing`,
    name: "POS_terminal",
    element: <CLIENTPrinting />,
    isCompanyAccount: true,
  },
  // {
  //   path: `/clients/:id/edaccount/explore-account`,
  //   name: "POS_terminal",
  //   element: <AccountContext />,
  //   isClient: true,
  // },
  {
    path: `/clients/:id/account/purchase-orders/create`,
    name: "purchase-orders",
    element: <PurchaseOrders />,
    isCompanyAccount: true,
  },

  {
    path: "/create_new_account",
    name: "student_apply",
    element: <Registration />,
    isPublic: true,
  },
  {
    path: "/company-registration/registered-success",
    name: "student_apply",
    element: <RegistrationSuccess />,
    isPublic: true,
  },
  {
    path: "/create_new_account/queries",
    name: "student_apply",
    element: <QueryRegistration />,
    isPublic: true,
  },
  {
    path: "/account-created/:plan/:_id/client/:clientId",
    name: "student_apply",
    element: <RegAdditionalSetup />,
    isPublic: true,
  },
];

export default greenRoutes;
